import { type BoundActionType, bindAction, createBoundAction } from 'app/common/utils/actions';
import type { Dispatch } from 'redux';

export type MultiSelectMeta = {
  multiSelectName: string;
};

export const toggleSelection = createBoundAction('multiSelect/TOGGLE_CONTENT_SELECTION')<MultiSelectMeta, string>();
export type ToggleSelectionAction = BoundActionType<typeof toggleSelection>;

export const toggleAllSelection = createBoundAction('multiSelect/TOGGLE_ALL_SELECTION')<MultiSelectMeta>();
export type ToggleAllSelectionAction = BoundActionType<typeof toggleAllSelection>;

export const clearSelection = createBoundAction('multiSelect/CLEAR_SELECTION')<MultiSelectMeta>();
export type ClearSelectionAction = BoundActionType<typeof clearSelection>;

export const initMultiSelect = createBoundAction('multiSelect/INIT_MULTI_SELECT')<MultiSelectMeta, string[]>();
export type InitMultiSelectAction = BoundActionType<typeof initMultiSelect>;

export const setFiltered = createBoundAction('multiSelect/SET_FILTERED')<MultiSelectMeta, string[]>();
export type SetFilteredAction = BoundActionType<typeof setFiltered>;

export type Actions =
  | ToggleSelectionAction
  | ToggleAllSelectionAction
  | ClearSelectionAction
  | InitMultiSelectAction
  | SetFilteredAction;

export type MultiSelectActions = {
  toggleSelection: ReturnType<typeof toggleSelection>;
  toggleAllSelection: ReturnType<typeof toggleAllSelection>;
  clearSelection: ReturnType<typeof clearSelection>;
  initMultiSelect: ReturnType<typeof initMultiSelect>;
};

export function bindActions(multiSelectName: string, dispatch: Dispatch): MultiSelectActions {
  const meta = { multiSelectName };
  return {
    toggleSelection: bindAction(toggleSelection, meta, dispatch),
    toggleAllSelection: bindAction(toggleAllSelection, meta, dispatch),
    clearSelection: bindAction(clearSelection, meta, dispatch),
    initMultiSelect: bindAction(initMultiSelect, meta, dispatch)
  };
}
